
export const BOARD_URL = 'rest/board/';
export const JWS_USER_URL = 'rest/user-token/';
export const ACTIVE_USER_URL = 'rest/active-users/';